import { useRef, useEffect } from 'react'

// Hook from our master, Dan Abramov. https://overreacted.io/making-setinterval-declarative-with-react-hooks/
export const useInterval = (callback: any, delay: number, waitPromise = false) => {
  const savedCallback = useRef()
  const promiseRef = useRef<Promise<any>>()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback && savedCallback.current && !promiseRef.current) {
        //@ts-ignore
        const result = savedCallback.current()

        // Save the promise state to "wait" until it is resolved before executing the callback with the next ticks
        if (waitPromise && result instanceof Promise) {
          result.catch().then(() => {
            promiseRef.current = undefined
          })
          promiseRef.current = result
        }
      }
    }
    if (delay !== null) {
      let id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay, waitPromise])
}
